export const termsOfServiceUrl =
  "https://www.asanowharton.com/terms-of-service/";
export const privacyPolicyUrl = "https://www.asanowharton.com/privacy-policy/";
